<template>
  <div id="app">
    <!-- 登录页 -->
    <div v-if="isLoginPage" class="login-wrapper">
      <router-view />
    </div>
    <!-- 主布局：极简白风格 -->
    <div v-else class="main-layout">
      <!-- 顶部一级导航 -->
      <div class="top-header">
        <div class="logo"><div class="dot">S</div> SCRM</div>
        <div class="main-nav">
          <div class="nav-item" :class="{active: activeNav==='home'}" @click="switchNav('home')">首页</div>
          <div v-if="showForeignTrade" class="nav-item has-dropdown" :class="{active: activeNav==='foreignTrade'}">
            外贸跨境专属
            <div class="dropdown-menu">
              <div v-if="hasRoute('/foreignTradeTwo')" class="dropdown-item" :class="{active: activeSubNav==='foreignTradeTwo'}" @click="switchSubNav('foreignTradeTwo', 'foreignTrade')">{{ routeTitle('/foreignTradeTwo', '找老外客户') }}<el-tooltip v-if="routeDesc('/foreignTradeTwo')" :content="routeDesc('/foreignTradeTwo')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
              <div v-if="hasRoute('/foreignTrade')" class="dropdown-item" :class="{active: activeSubNav==='foreignTrade'}" @click="switchSubNav('foreignTrade', 'foreignTrade')">{{ routeTitle('/foreignTrade', '找国内客户') }}<el-tooltip v-if="routeDesc('/foreignTrade')" :content="routeDesc('/foreignTrade')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
            </div>
          </div>
          <div v-if="showCustomer" class="nav-item has-dropdown" :class="{active: activeNav==='customer'}">
            企业核验线索
            <div class="dropdown-menu">
              <div v-if="hasRoute('/clue')" class="dropdown-item" :class="{active: activeSubNav==='clue'}" @click="switchSubNav('clue', 'customer')">{{ routeTitle('/clue', '企业线索') }}<el-tooltip v-if="routeDesc('/clue')" :content="routeDesc('/clue')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
              <div v-if="hasRoute('/batch-query')" class="dropdown-item" :class="{active: activeSubNav==='batchQuery'}" @click="switchSubNav('batchQuery', 'customer')">{{ routeTitle('/batch-query', '批量查询企业线索') }}<el-tooltip v-if="routeDesc('/batch-query')" :content="routeDesc('/batch-query')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
              <div v-if="hasRoute('/gth')" class="dropdown-item" :class="{active: activeSubNav==='gth'}" @click="switchSubNav('gth', 'customer')">{{ routeTitle('/gth', '个体户企业') }}<el-tooltip v-if="routeDesc('/gth')" :content="routeDesc('/gth')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
            </div>
          </div>
          <div v-if="showGroup" class="nav-item has-dropdown" :class="{active: activeNav==='group'}">
            企业人群包
            <div class="dropdown-menu">
              <div v-if="hasRoute('/taxpayer')" class="dropdown-item" :class="{active: activeSubNav==='taxpayer'}" @click="switchSubNav('taxpayer', 'group')">{{ routeTitle('/taxpayer', '一般纳税人') }}<el-tooltip v-if="routeDesc('/taxpayer')" :content="routeDesc('/taxpayer')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
              <div v-if="hasRoute('/texin')" class="dropdown-item" :class="{active: activeSubNav==='texin'}" @click="switchSubNav('texin', 'group')">{{ routeTitle('/texin', '专精特新企业') }}<el-tooltip v-if="routeDesc('/texin')" :content="routeDesc('/texin')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
              <div v-if="hasRoute('/taxa')" class="dropdown-item" :class="{active: activeSubNav==='taxa'}" @click="switchSubNav('taxa', 'group')">{{ routeTitle('/taxa', '纳税A级') }}<el-tooltip v-if="routeDesc('/taxa')" :content="routeDesc('/taxa')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
              <div v-if="hasRoute('/selfemployee')" class="dropdown-item" :class="{active: activeSubNav==='selfemployee'}" @click="switchSubNav('selfemployee', 'group')">{{ routeTitle('/selfemployee', '个体户银联码') }}<el-tooltip v-if="routeDesc('/selfemployee')" :content="routeDesc('/selfemployee')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
              <div v-if="hasRoute('/winning')" class="dropdown-item" :class="{active: activeSubNav==='winning'}" @click="switchSubNav('winning', 'group')">{{ routeTitle('/winning', '中标企业') }}<el-tooltip v-if="routeDesc('/winning')" :content="routeDesc('/winning')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
            </div>
          </div>
          <div v-if="showAnnualCompanyComputed" class="nav-item" :class="{active: activeNav==='annualCompany'}" @click="switchNav('annualCompany')">{{ routeTitle('/annualCompany', 'KP分值') }}<el-tooltip v-if="routeDesc('/annualCompany')" :content="routeDesc('/annualCompany')" placement="top" effect="dark"><i class="el-icon-warning-outline nav-desc-icon" @click.stop></i></el-tooltip></div>
          <div class="nav-item" :class="{active: activeNav==='custom'}" @click="switchNav('custom')">高级定制服务</div>
          <div class="nav-item" :class="{active: activeNav==='bill'}" @click="switchNav('bill')">账单</div>
        </div>
        <div class="header-right">
          <span class="balance-text">余额：<strong>{{pointInfo.point}}</strong>积分</span>
          <span class="recharge-link" @click="handleRecharge">充值</span>
          <el-dropdown trigger="click">
            <div class="user-info">
              <i class="el-icon-user-solid" style="font-size:18px;"></i>
              {{userName}}
              <i class="el-icon-arrow-down" style="font-size:11px;"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-edit" @click.native="changePwdVisible = true">修改密码</el-dropdown-item>
              <el-dropdown-item icon="el-icon-switch-button" divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- 页面标题栏 -->
      <div class="sub-header" v-if="currentPageTitle">
        <div class="current-page-title">{{ currentPageTitle }}</div>
      </div>

      <!-- 页面描述横幅 -->
      <div class="page-desc-banner" v-if="currentPageDesc">
        <i class="el-icon-warning-outline"></i>
        <span class="page-desc-text">{{ currentPageDesc }}</span>
      </div>

      <!-- 内容区域 -->
      <div class="content-area">
        <router-view />
      </div>
      <div class="app-footer">Copyright © 2023-2026 SCRM Inc.</div>

      <!-- 修改密码 -->
      <el-dialog title="修改密码" :visible.sync="changePwdVisible" width="440px" :close-on-click-modal="false">
        <el-form :model="pwdForm" label-width="80px">
          <el-form-item label="手机号"><el-input v-model="pwdForm.phone" disabled /></el-form-item>
          <el-form-item label="新密码"><el-input v-model="pwdForm.password" type="password" placeholder="新密码" /></el-form-item>
          <el-form-item label="确认密码"><el-input v-model="pwdForm.confirmedPassword" type="password" placeholder="确认密码" /></el-form-item>
          <el-form-item label="验证码">
            <div style="display:flex;gap:8px">
              <el-input v-model="pwdForm.code" placeholder="验证码" />
              <el-button @click="sendCode" :disabled="codeDisabled">{{codeText}}</el-button>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="changePwdVisible = false">取消</el-button>
          <el-button type="primary" @click="submitChangePwd">确定</el-button>
        </span>
      </el-dialog>
      <!-- 充值 -->
      <el-dialog title="充值中心" :visible.sync="rechargeVisible" width="680px" top="8vh">
        <RechargeMain @renew="refreshPoints" @close="rechargeVisible = false" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import auth from "./auth"
import appInfo from "./app-info"
import RechargeMain from "@/views/recharge/RechargeMain"

// 导航路由映射
const navRouteMap = {
  home: '/home',
  customer_gth: '/gth',
  customer_clue: '/clue',
  group_taxpayer: '/taxpayer',
  group_texin: '/texin',
  group_taxa: '/taxa',
  group_selfemployee: '/selfemployee',
  group_winning: '/winning',
  customer_batchQuery: '/batch-query',
  annualCompany: '/annualCompany',
  custom: '/custom-service',
  bill: '/bill',
  foreignTrade: '/foreignTrade',
  foreignTrade_foreignTrade: '/foreignTrade',
  foreignTrade_foreignTradeTwo: '/foreignTradeTwo'
}

export default {
  components: { RechargeMain },
  provide() {
    return { appNav: this }
  },
  data() {
    return {
      activeNav: 'home',
      activeSubNav: '',
      changePwdVisible: false,
      rechargeVisible: false,
      pwdForm: { phone: '', password: '', confirmedPassword: '', code: '' },
      codeText: '获取验证码',
      codeDisabled: false,
      pointInfo: { point: 0, usedPoint: 0, consumeA: 0, consumeB: 0 },
      pointInfoReady: false,
      onlineRecharge: false,
      markOptions: appInfo.markOptions,
      userName: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).username || 'admin' : 'admin',
      userRoutes: [] // 响应式路由权限数据
    }
  },
  computed: {
    isLoginPage() { return this.$route.path === '/login' },
    showForeignTrade() { return this.hasRoute('/foreignTrade') || this.hasRoute('/foreignTradeTwo') },
    showCustomer() { return this.hasRoute('/clue') || this.hasRoute('/batch-query') || this.hasRoute('/gth') },
    showGroup() { return this.hasRoute('/taxpayer') || this.hasRoute('/texin') || this.hasRoute('/taxa') || this.hasRoute('/selfemployee') || this.hasRoute('/winning') },
    showAnnualCompanyComputed() { return appInfo.showAnnualCompany && this.hasRoute('/annualCompany') },
    subNavItems() {
      const map = {
        customer: [{ key: 'clue', label: '企业线索' }, { key: 'batchQuery', label: '批量查询企业线索' }, { key: 'gth', label: '个体户企业' }],
        group: [{ key: 'taxpayer', label: '一般纳税人' }, { key: 'texin', label: '专精特新企业' }, { key: 'taxa', label: '纳税A级' }, { key: 'selfemployee', label: '个体户银联码' }, { key: 'winning', label: '中标企业' }],
        foreignTrade: [{ key: 'foreignTradeTwo', label: '全球搜索' }, { key: 'foreignTrade', label: '外贸人群包' }],
      }
      return map[this.activeNav] || []
    },
    currentPageTitle() {
      const subPathMap = {
        clue: '/clue',
        batchQuery: '/batch-query',
        gth: '/gth',
        taxpayer: '/taxpayer',
        texin: '/texin',
        taxa: '/taxa',
        selfemployee: '/selfemployee',
        winning: '/winning',
        foreignTrade: '/foreignTrade',
        foreignTradeTwo: '/foreignTradeTwo',
      }
      const navPathMap = {
        annualCompany: '/annualCompany',
      }
      const defaultMap = {
        clue: '企业线索',
        batchQuery: '批量查询企业线索',
        gth: '个体户企业',
        annualCompany: 'KP分值',
        taxpayer: '一般纳税人',
        texin: '专精特新企业',
        taxa: '纳税A级',
        selfemployee: '个体户银联码',
        winning: '中标企业',
        foreignTrade: '外贸人群包',
        foreignTradeTwo: '全球搜索',
      }
      const subPath = subPathMap[this.activeSubNav]
      if (subPath) return this.routeTitle(subPath, defaultMap[this.activeSubNav] || '')
      const navPath = navPathMap[this.activeNav]
      if (navPath) return this.routeTitle(navPath, defaultMap[this.activeNav] || '')
      return ''
    },
    currentPageDesc() {
      const subPathMap = {
        clue: '/clue',
        batchQuery: '/batch-query',
        gth: '/gth',
        taxpayer: '/taxpayer',
        texin: '/texin',
        taxa: '/taxa',
        selfemployee: '/selfemployee',
        winning: '/winning',
        foreignTrade: '/foreignTrade',
        foreignTradeTwo: '/foreignTradeTwo',
      }
      const subPath = subPathMap[this.activeSubNav]
      if (subPath) {
        const route = this.userRoutes.find(r => r.path === subPath)
        if (route && route.description) return route.description
        // 中标企业默认描述
        if (this.activeSubNav === 'winning') return '\u9002\u5408\u884C\u4E1A\uFF1A\u4F01\u4E1A\u4E2D\u6807\u8D37\u3001\u653F\u5E9C\u5173\u7CFB\u3001\u767D\u9152\u7B49\u884C\u4E1A'
      }
      return ''
    }
  },
  watch: {
    '$route.path'(path) {
      this.syncNavFromRoute(path)
    },
    isLoginPage(val, oldVal) {
      if (oldVal === true && !val && auth.loggedIn()) {
        this.initUserData()
      }
    }
  },
  mounted() {
    if (!this.isLoginPage && auth.loggedIn()) {
      this.initUserData()
    }
    this.syncNavFromRoute(this.$route.path)
  },
  methods: {
    hasRoute(path) {
      const publicPaths = ['/home', '/login', '/bill', '/custom-service', '/kefu', '/no-permission']
      if (publicPaths.includes(path)) return true
      if (!this.userRoutes || this.userRoutes.length === 0) return false
      return this.userRoutes.some(r => r.path === path)
    },
    routeTitle(path, defaultTitle) {
      if (!this.userRoutes || this.userRoutes.length === 0) return defaultTitle
      const r = this.userRoutes.find(r => r.path === path)
      return (r && r.title) ? r.title : defaultTitle
    },
    routeDesc(path) {
      if (!this.userRoutes || this.userRoutes.length === 0) return ''
      const r = this.userRoutes.find(r => r.path === path)
      return (r && r.description) ? r.description : ''
    },
    loadUserRoutes() {
      this.$http.getUserRoute().then(res => {
        if (res.status === 'success' && res.data) {
          this.userRoutes = res.data
          localStorage.setItem('userRoutes', JSON.stringify(res.data))
        } else {
          this.userRoutes = []
        }
      }).catch(() => {
        // 从localStorage兜底
        const saved = localStorage.getItem('userRoutes')
        this.userRoutes = saved ? JSON.parse(saved) : []
      })
    },
    syncNavFromRoute(path) {
      if (path === '/home') { this.activeNav = 'home'; this.activeSubNav = '' }
      else if (path === '/gth') { this.activeNav = 'customer'; this.activeSubNav = 'gth' }
      else if (path === '/clue') { this.activeNav = 'customer'; this.activeSubNav = 'clue' }
      else if (path === '/batch-query') { this.activeNav = 'customer'; this.activeSubNav = 'batchQuery' }
      else if (path === '/annualCompany') { this.activeNav = 'annualCompany'; this.activeSubNav = '' }
      else if (path === '/taxpayer') { this.activeNav = 'group'; this.activeSubNav = 'taxpayer' }
      else if (path === '/texin') { this.activeNav = 'group'; this.activeSubNav = 'texin' }
      else if (path === '/taxa') { this.activeNav = 'group'; this.activeSubNav = 'taxa' }
      else if (path === '/selfemployee') { this.activeNav = 'group'; this.activeSubNav = 'selfemployee' }
      else if (path === '/winning') { this.activeNav = 'group'; this.activeSubNav = 'winning' }
      else if (path === '/bill') { this.activeNav = 'bill'; this.activeSubNav = '' }
      else if (path === '/custom-service') { this.activeNav = 'custom'; this.activeSubNav = '' }
      else if (path === '/foreignTrade') { this.activeNav = 'foreignTrade'; this.activeSubNav = 'foreignTrade' }
      else if (path === '/foreignTradeTwo') { this.activeNav = 'foreignTrade'; this.activeSubNav = 'foreignTradeTwo' }
    },
    switchNav(nav) {
      this.activeNav = nav
      if (nav === 'home') { this.activeSubNav = ''; this.$router.push('/home').catch(() => {}) }
      else if (nav === 'annualCompany') { this.activeSubNav = ''; this.$router.push('/annualCompany').catch(() => {}) }
      else if (nav === 'custom') { this.activeSubNav = ''; this.$router.push('/custom-service').catch(() => {}) }
      else if (nav === 'bill') { this.activeSubNav = ''; this.$router.push('/bill').catch(() => {}) }
      else if (nav === 'foreignTrade') {
        if (this.subNavItems.length > 0) {
          this.activeSubNav = this.subNavItems[0].key
          this.$router.push('/foreignTradeTwo').catch(() => {})
        }
      }
      else if (nav === 'customer') {
        if (this.subNavItems.length > 0) {
          this.activeSubNav = this.subNavItems[0].key
          this.$router.push('/clue').catch(() => {})
        }
      } else if (nav === 'group') {
        if (this.subNavItems.length > 0) {
          this.activeSubNav = this.subNavItems[0].key
          this.$router.push('/taxpayer').catch(() => {})
        }
      }
    },
    switchSubNav(key, parentNav) {
      this.activeNav = parentNav
      this.activeSubNav = key
      if (parentNav === 'customer') {
        const pathMap = { clue: '/clue', gth: '/gth', batchQuery: '/batch-query' }
        const path = pathMap[key]
        if (path && this.$route.path !== path) this.$router.push(path).catch(() => {})
      } else if (parentNav === 'group') {
        const pathMap = { taxpayer: '/taxpayer', texin: '/texin', taxa: '/taxa', selfemployee: '/selfemployee', winning: '/winning' }
        const path = pathMap[key]
        if (path && this.$route.path !== path) this.$router.push(path).catch(() => {})
      } else if (parentNav === 'foreignTrade') {
        const pathMap = { foreignTrade: '/foreignTrade', foreignTradeTwo: '/foreignTradeTwo' }
        const path = pathMap[key]
        if (path && this.$route.path !== path) this.$router.push(path).catch(() => {})
      }
    },
    handleRecharge() {
      if (this.onlineRecharge) {
        this.rechargeVisible = true
      } else {
        this.$message.warning('请联系客服充值')
      }
    },
    checkOnlineRecharge() {
      this.$http.sysResGetRes(3).then(r => {
        if (r.data && r.data.content1 === '1') this.onlineRecharge = true
      }).catch(() => {})
    },
    logout() {
      auth.logOut()
      this.$router.push('/login')
    },
    initUserData() {
      this.refreshPoints()
      this.getBindPhone()
      this.checkOnlineRecharge()
      this.loadUserRoutes()
      let token = localStorage.getItem("token")
      if (token) this.$websocket.initWebSocket(token)
    },
    refreshPoints() {
      this.$http.getPointCountView().then(r => { if (r.data) { this.pointInfo = r.data; this.pointInfoReady = true } })
    },
    getBindPhone() {
      this.$http.getBindPhone().then(r => { if (r.data) this.pwdForm.phone = r.data })
    },
    sendCode() {
      if (!this.pwdForm.phone) { this.$message.error('手机号不存在'); return }
      this.$http.getCode({ phone: this.pwdForm.phone }).then(r => {
        if (r.status === 'success') {
          this.$message.success(r.msg)
          this.codeDisabled = true
          let sec = 60
          const timer = setInterval(() => { sec--; this.codeText = sec + 's后重试'; if (sec <= 0) { clearInterval(timer); this.codeText = '获取验证码'; this.codeDisabled = false } }, 1000)
        } else { this.$message.error(r.msg) }
      })
    },
    submitChangePwd() {
      if (!this.pwdForm.password) { this.$message.error('请输入密码'); return }
      if (this.pwdForm.password !== this.pwdForm.confirmedPassword) { this.$message.error('两次密码不一致'); return }
      if (!this.pwdForm.code) { this.$message.error('请输入验证码'); return }
      this.$http.updatePassword(this.pwdForm).then(r => {
        if (r.status === 'success') {
          this.$message.success('密码修改成功，请重新登录')
          this.changePwdVisible = false
          this.logout()
        } else { this.$message.error(r.msg) }
      })
    }
  }
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
html, body, #app { height: 100%; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif; background: #f7f8fa; }

/* 登录页 */
.login-wrapper { height: 100vh; }

/* 主布局 */
.main-layout { display: flex; flex-direction: column; height: 100vh; }

/* 顶部栏 */
.top-header { height: 56px; background: #fff; display: flex; align-items: center; padding: 0 32px; border-bottom: 1px solid #e8e8e8; flex-shrink: 0; z-index: 10; }
.top-header .logo { font-size: 20px; font-weight: 700; color: #303133; margin-right: 40px; display: flex; align-items: center; gap: 8px; }
.top-header .logo .dot { width: 28px; height: 28px; border-radius: 8px; background: #409eff; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 800; }
.top-header .main-nav { display: flex; gap: 4px; flex: 1; }
.top-header .main-nav .nav-item { padding: 8px 18px; border-radius: 6px; font-size: 14px; color: #606266; cursor: pointer; transition: all 0.15s; position: relative; }
.top-header .main-nav .nav-item:hover { color: #409eff; background: #f0f7ff; }
.top-header .main-nav .nav-item.active { color: #409eff; font-weight: 600; background: #f0f7ff; }

.top-header .main-nav .nav-item .dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-radius: 6px;
  padding: 6px 0;
  min-width: 160px;
  z-index: 100;
}
.top-header .main-nav .nav-item.has-dropdown::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: 4px;
  background: transparent;
  z-index: 101;
}
.top-header .main-nav .nav-item.has-dropdown:hover .dropdown-menu,
.top-header .main-nav .nav-item .dropdown-menu:hover {
  display: block;
}

.dropdown-item {
  padding: 8px 16px;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.dropdown-item:hover,
.dropdown-item.active {
  color: #409eff;
  background: #f0f7ff;
}

.top-header .header-right { display: flex; align-items: center; gap: 16px; }
.top-header .balance-text { font-size: 13px; color: #909399; }
.top-header .balance-text strong { color: #409eff; font-size: 16px; margin: 0 2px; }
.top-header .recharge-link { color: #409eff; font-size: 13px; cursor: pointer; font-weight: 500; }
.top-header .recharge-link:hover { text-decoration: underline; }
.top-header .user-info { display: flex; align-items: center; gap: 6px; cursor: pointer; color: #606266; font-size: 13px; }

/* 页面标题栏 */
.sub-header { height: 44px; background: #e8f0fe; display: flex; align-items: center; padding: 0 32px; border-bottom: 1px solid #c9d8eb; flex-shrink: 0; }
.sub-header .current-page-title { font-size: 16px; font-weight: 700; color: #303133; }

/* 页面描述横幅 */
.page-desc-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 32px;
  background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);
  border-bottom: 2px solid #FFB74D;
  flex-shrink: 0;
}
.page-desc-banner .el-icon-warning-outline {
  font-size: 22px;
  color: #E65100;
  flex-shrink: 0;
}
.page-desc-banner .page-desc-text {
  font-size: 18px;
  font-weight: 700;
  color: #BF360C;
  letter-spacing: 0.5px;
}

.nav-desc-icon { margin-left: 4px; font-size: 13px; color: #e6a23c; cursor: pointer; vertical-align: middle; }
.nav-desc-icon:hover { color: #cf8d17; }

/* 内容区域 */
.content-area { flex: 1; overflow-y: auto; padding: 24px 32px; }

/* 底部 */
.app-footer { text-align: center; padding: 14px; color: #dcdfe6; font-size: 12px; flex-shrink: 0; }

/* 全局弹窗圆角 */
.el-dialog { border-radius: 12px !important; }
.el-dialog__header { border-bottom: 1px solid #f0f0f0; padding-bottom: 16px !important; }
.el-dialog__footer { border-top: 1px solid #f0f0f0; padding-top: 16px !important; }
</style>
